module.exports = __webpack_public_path__ + "static/media/daizika-logo.a5ae760a.png";